import { useDispatch } from "react-redux";
import { NavLink } from "react-router";

import { togglePinStatePbxToRecents } from "@/store/reducers/settings";
import useColor from "@/utils/hooks/useColor";
import Valkyrie, { viGear, viThumbtack, viThumbtackSlash } from "@sippy-platform/valkyrie";

import { Box, Button, ButtonBase, Card, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function PbxCardHighlighted({ pbx }) {
  const { color, background } = useColor(pbx.name);
  const dispatch = useDispatch();

  return (
    <Card
      sx={{
        color: color,
        background: `linear-gradient(135deg, ${background[300]} 0%, ${background[400]} 100%)`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <ButtonBase
        component={NavLink}
        to={`/pbx/${pbx.context}/dashboard`}
        sx={{
          px: 1.5,
          pt: 1,
          pb: 0,
          textAlign: "left",
          fontFamily: "revert",
          flexGrow: 1,
          alignItems: "start",
          justifyContent: "start",
          minHeight: { sx: 32, sm: 40, lg: 48 },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "1.25rem",
            lineHeight: 1.3,
            marginBottom: 0,
          }}
        >
          {pbx.name}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
      </ButtonBase>
      <Stack
        direction="row"
        sx={{
          gap: 0.5,
          alignItems: "center",
          justifyContent: "space-between",
          p: 0.5,
          pl: 1.5,
        }}
      >
        <Typography sx={{ fontSize: ".75rem" }}>{pbx.context}</Typography>
        <Stack
          direction="row"
          sx={{
            gap: 0.5,
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="small"
            component={NavLink}
            to={`/pbx/${pbx.context}/my-pbx`}
            sx={{
              fontSize: ".75rem",
              color,
              height: 24,
            }}
            startIcon={<Valkyrie icon={viGear} />}
          >
            Settings
          </Button>
          <Button
            size="small"
            onClick={() => dispatch(togglePinStatePbxToRecents(pbx))}
            sx={{
              fontSize: ".75rem",
              color,
              height: 24,
              width: 24,
            }}
          >
            <Valkyrie icon={pbx.pinned === 0 ? viThumbtack : viThumbtackSlash} />
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}

PbxCardHighlighted.propTypes = {
  pbx: PropTypes.object,
};
